import * as React from 'react';
/**
 *
 * Original name: camera upload
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=35690%3A9692
 *
 */
export const CameraUploadFill = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M18.295 2.25 21.155 5l-1.04 1.081-1.07-1.029v3.739h-1.5v-3.74l-1.07 1.029L15.435 5l2.86-2.75Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.058 12.796v3.954a2.249 2.249 0 0 1-2.25 2.25h-11.5a2.25 2.25 0 0 1-2.25-2.25L3 7h4.017L8 5h5.25l5.808 7.796Zm-10.16 1.807c.387.388 1.035.647 2.102.647s1.715-.26 2.103-.647c.388-.388.647-1.036.647-2.103 0-1.067-.26-1.715-.647-2.103-.388-.388-1.036-.647-2.103-.647-1.067 0-1.715.26-2.103.647-.388.388-.647 1.036-.647 2.103 0 1.067.26 1.715.647 2.103Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
